
        (function() {

          var el = document.createElement("script");

          el.setAttribute("src", "https://assets.gocertify.me/assets/gocertify.js");

          el.setAttribute("data-brand", "decree");

          el.setAttribute("defer", "true");

          document.head.appendChild(el);

        })();